<template>
  <div>
    <vs-popup
      :title="$t('CreateNewWarehouseHandling')"
      :active.sync="showModal"
    >
      <form>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input
              class="inputx mb-4 mt-1"
              v-model="model.title"
              name="title"
              :label="$t('Title')"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('title')">{{
              errors.first("title")
            }}</span>
          </div>
          <div class="vx-col w-full mb-4">
            <label class="vs-select--label">{{ $t("WarehouseName") }}</label>
            <v-select
              class="m-0"
              label="name"
              name="warehouse"
              :options="allWarehouses"
              v-model="model.storeId"
              v-validate="{ required: true }"
              :reduce="(x) => x.id"
              dir="rtl"
            >
            </v-select>
            <span
              class="text-danger text-sm mt-4"
              v-show="errors.has('warehouse')"
              >{{ errors.first("warehouse") }}</span
            >
          </div>
          <div class="vx-col w-full">
            <vs-input
              class="inputx mb-4 mt-1"
              v-model="model.description"
              name="description"
              :label="$t('Description')"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button
              type="filled"
              class="float-right mb-4"
              @click.prevent="submitForm"
              >{{ $t("Save") }}</vs-button
            >
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";

const dict = {
  custom: {
    title: {
      required: "لطفا عنوان انبارگردانی را وارد نمایید.",
    },
    year: {
      required: "لطفا سال انبارگردانی را وارد نمایید.",
    },
    description: {
      required: "لطفا توضیحات انبارگردانی را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "Warehouse-WarehouseHanding-Create",
  components: {
    "v-select": vSelect,
  },
  props: {
    show: { default: false },
  },
  data() {
    return {
      isActive: true,
      model: {},
    };
  },
  computed: {
    ...mapGetters({
      allWarehouses: "warehouse/listWithShelves",
    }),
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      fetchWarehouses: "warehouse/fetchList",
      createStockTaking: "warehouseHandling/create",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createStockTaking(this.model).then(() => {
            this.$emit("finish");
            this.model = {};
            this.$validator.reset();
          });
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.fetchWarehouses();
      }
    },
  },
};
</script>
